import { ACTION_TYPES } from '../actions'

const initialState = { broadcast: null, overdueCredit: null }

export const popupReducer = (state = initialState, action) => {
	switch (action.type) {
		case ACTION_TYPES.POPUP:
			return action.payload
		default:
			return state
	}
}
